module.exports = __webpack_public_path__ + "img/wtb10.d4c3563e.png";